// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9bb84f57","455":"4c54a93a"}[chunkId] + ".chunk.js";
};